import { MouseEvent } from "react";
import styles from "./WideButton.module.css";

interface WideButtonProps {
    title: string,
    desc: string,
    onClick?: (e?: MouseEvent<HTMLElement>) => void;
}

/**
 * 신규 장소 등록 선택 화면
 * @author mjkang
 * @date 2024-09-12 10:14:32
 * @param props: WideButtonProps
 * @props changeContent: 사이드 시트 콘텐츠를 변경하는 함수
 */
const WideButton = (props: WideButtonProps) => {

    return (
        <div className={styles.wrapper} onClick={props.onClick}>
            <div className={styles.title}>{props.title}</div>
            <div className={styles.desc}>{props.desc}</div>
        </div>
    );
};

export default WideButton;
